function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "talk",
  d: "M.28,1.614v11.94H3.464v4.08l1.294-1.095,3.781-2.985H16.2V.818H.28Zm14.328.8v9.552H7.942l-.2.2-2.687,2.09V11.962H1.872V2.41Zm3.184,3.184h3.184v9.552H17.792v2.289l-2.886-2.289H8.937l-1.99,1.592H14.31l5.075,4.08v-4.08h3.184V4H17.792Z",
  transform: "translate(0.22 -0.318)",
  fill: "#fff",
  stroke: "#707070",
  strokeLinejoin: "bevel",
  strokeWidth: 1,
  fillRule: "evenodd"
});

var SvgTalk = function SvgTalk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23.288,
    height: 20.89,
    viewBox: "0 0 23.288 20.89",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/talk.4d00213c.svg";
export { ForwardRef as ReactComponent };